// extracted by mini-css-extract-plugin
export default {"morePartners":"MorePartners_morePartners__VSsJk","morePartners__inner":"MorePartners_morePartners__inner__-6cN9","morePartners__grid":"MorePartners_morePartners__grid__s7DNE"};